import Vue from 'vue'
import Router from 'vue-router'

import Main from './Main.vue'
import Ask from './Ask.vue'
import Profile from './Profile.vue'
import Pins from './Pins.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history', 
  routes: [
    {path: '/', component: Main},
    {path: '/ask', component: Ask},
    {path: '/profile', component: Profile},
    {path: '/pins', component: Pins},
    {path: '/:questionId', component: Main},
  ]
})

export default router
